"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Config_1 = require("../../Config");
const CrudRepository_1 = require("../CrudRepository");
const index_1 = require("./index");
class AwardRepository extends CrudRepository_1.CrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.AWARD);
        this.getBySpaceAndFilterLive = (space, filter = index_1.AwardFilter.ALL) => {
            const fieldName = ['space'];
            const fieldValue = [space];
            const operator = [interfaces_1.Opr.EQUAL];
            switch (filter) {
                case index_1.AwardFilter.ACTIVE: {
                    fieldName.push('endDate', 'completed', 'approved');
                    fieldValue.push(new Date().toISOString(), false, true);
                    operator.push(interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL);
                    break;
                }
                case index_1.AwardFilter.COMPLETED: {
                    fieldName.push('completed', 'approved');
                    fieldValue.push(true, true);
                    operator.push(interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL);
                    break;
                }
                case index_1.AwardFilter.DRAFT: {
                    fieldName.push('endDate', 'rejected', 'approved');
                    fieldValue.push(new Date().toISOString(), false, false);
                    operator.push(interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL);
                    break;
                }
                case index_1.AwardFilter.REJECTED: {
                    fieldName.push('rejected');
                    fieldValue.push(true);
                    operator.push(interfaces_1.Opr.EQUAL);
                    break;
                }
            }
            const params = { collection: this.col, fieldName, fieldValue, operator };
            return this.getManyAdvancedLive(params);
        };
        this.getLastActiveLive = (startAfter) => {
            const fieldName = ['endDate', 'completed', 'approved'];
            const fieldValue = [new Date().toISOString(), false, true];
            const operator = [interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL];
            const orderBy = ['endDate'];
            const params = { collection: this.col, fieldName, fieldValue, operator, startAfter, orderBy };
            return this.getManyAdvancedLive(params);
        };
        this.getTopByMemberLive = (member, completed, startAfter) => {
            const members = this.participantRepo.getTopByMemberLive(member, completed, startAfter);
            return members.pipe((0, rxjs_1.switchMap)(async (members) => {
                const promises = members.map((member) => this.getById(member.parentId));
                return (await Promise.all(promises)).map((s) => s);
            }));
        };
        this.participantRepo = new index_1.AwardParticipantRepository(env);
    }
}
exports.AwardRepository = AwardRepository;
